import { FormikContextType, getIn } from 'formik';
import { useState } from 'react';

// formik's `handleChange` runs `parseFloat` on `type="number"` inputs, so typing "0.0" stores `0`
// and the controlled input gets re-rendered as "0" (trailing zero gone before the next digit lands).
// Keep the raw text as the displayed value while it still represents the stored number, and only
// write the parsed number into formik.
export const useNumericInputDraft = (formik: FormikContextType<Record<string, unknown>>, name: string) => {
  const [draft, setDraft] = useState<string | null>(null);
  const stored = getIn(formik.values, name);
  const isDraftCurrent = draft !== null && (draft === '' ? stored === '' : Number(draft) === stored);

  const onIonInput = (event: CustomEvent<{ value?: string | null }>) => {
    const raw = event.detail?.value ?? '';
    const parsed = parseFloat(raw);
    setDraft(raw);
    formik.setFieldValue(name, isNaN(parsed) ? '' : parsed);
  };

  return { value: isDraftCurrent ? draft : stored, onIonInput };
};
